import script from "./ageInsertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ageInsertModal.vue?vue&type=script&setup=true&lang=js"

import "./ageInsertModal.vue?vue&type=style&index=0&id=18bb2acf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18bb2acf"]])

export default __exports__